/** @jsxRuntime classic */
/** @jsx jsx */
import { css, jsx } from "@emotion/react";
import { Popover } from "@material-ui/core";
import { Block, Delete } from "@material-ui/icons";
import React from "react";
import { Button } from "ui/chakra/components/Button";

import type { UserMessage } from "@spwn/types/firebase/firestore";

type Props = {
  target: React.RefObject<HTMLElement>;
  banTargetComment: Pick<UserMessage, "_id" | "uid"> | undefined;
  disableUserBlock: boolean;
  onClose: () => void;
  onClickBanUser: (comment: Pick<UserMessage, "_id" | "uid">) => Promise<void>;
  onClickBanComment: (idx: string) => Promise<void>;
};

const buttonStyle = css`
  padding: 8px 4px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  row-gap: 8px;
`;

const hoverStyle = css`
  width: 100%;
  justify-content: flex-start;
  &:hover:not(:disabled) {
    background-color: rgba(0, 0, 0, 0.04);
  }
`;

// 管理者によるコメント削除前の確認ダイアログ
export const StreamingCommentBanDialog: React.FC<Props> = (props) => {
  if (!props.banTargetComment) return null;

  return (
    <Popover
      open={!!props.banTargetComment}
      onBackdropClick={props.onClose}
      anchorEl={props.target.current}
      anchorOrigin={{
        vertical: "bottom",
        horizontal: "center",
      }}
      transformOrigin={{
        vertical: "top",
        horizontal: "left",
      }}
    >
      <div css={buttonStyle}>
        <Button
          size="sm"
          variant="ghost"
          disabled={props.disableUserBlock}
          onClick={async () => {
            if (!props.banTargetComment) return;
            await props.onClickBanUser(props.banTargetComment);
            props.onClose();
          }}
          leftIcon={<Block />}
          css={hoverStyle}
        >
          ユーザーブロック
        </Button>
        <Button
          size="sm"
          variant="ghost"
          onClick={async () => {
            if (!props.banTargetComment?._id) return;
            await props.onClickBanComment(props.banTargetComment._id);
            props.onClose();
          }}
          leftIcon={<Delete />}
          css={hoverStyle}
        >
          コメント削除
        </Button>
      </div>
    </Popover>
  );
};
